<template>
  <div class="cartcontrol">
    <transition name="move">
      <div class="cart-decrease" v-show="food.count>0" @click.stop="decrease">
        <span class="inner iconfont">&#xe693;</span>
      </div>
    </transition>
    <div class="cart-count" v-show="food.count>0">{{food.count}}</div>
    <div class="cart-add iconfont" @click.stop="add">&#xe692;</div>
  </div>
</template>

<script>
import { addCart, editCart, delCart } from '../../../../api/memberCart'
import { mapState } from 'vuex'
import { Toast, MessageBox } from 'mint-ui'
const EVENT_ADD = 'add'

export default {
  name: 'cart-control',
  props: {
    parentFood: {
      type: Object
    }
  },
  data(){
    return {
      loading: false,
      food: this.parentFood,
    }
  },
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline
    })
  },
  methods: {
    add () {
      if (this.food.spec_value == '') {
        if (!this.isOnline) {
          Toast(this.$t('guest.need_more_please_login'))          
          return
        }
        if(this.loading){
          Toast(this.$t('general.slowdown'))
          return
        }
        if (!this.food.count) {
          // 新增购物车数量操作
          this.addCart()
        } else {
          // 在原有基础上新增库存
          let count = this.food.count + 1
          this.editCart(count)
        }
        this.$emit('syncFood',this.food)
      } else {
        this.$emit('showSpec',this.food)
      }
    },
    decrease () {
      if(this.food.spec_value=='') {
        if(this.loading){
          Toast(this.$t('general.slowdown'))
          return
        }
        if (this.food.count > 1) {
          // 商品数量大于1 进行减数量操作
          let count = this.food.count - 1
          this.editCart(count)
        } else if (this.food.count > 0) {          
          // 商品数量小于等于1且大於0 进行删除购物车数据操作
          this.food.count--
          this.delCart()
        }
        this.$emit('syncFood',this.food)
      } else {
        this.$emit('showSpec',this.food)
      }
    },
    async update(mnumber,goods_id){
      var count = 0
      for (var i in this.food.spec_list) {
        if (this.food.spec_list[i].goods_id == goods_id) {
          if (mnumber > 0) {
            if (!this.food.spec_list[i].count) {
              await this.addCart(mnumber,goods_id)
            } else {
              this.food.spec_list[i].count = mnumber
              this.editCart(mnumber,this.food.spec_list[i].cart_id)
            }
          } else if (this.food.spec_list[i].cart_id) {
            this.food.spec_list[i].count = mnumber
            this.delCart(this.food.spec_list[i].cart_id)
          }
          count += mnumber
          this.food.spec_list[i].count = mnumber
        } else {
          if (this.food.spec_list[i].count) {
            count += this.food.spec_list[i].count
          }
        }
      }
      this.$set(this.food, 'count', count)
      this.$emit('syncFood', this.food)
    },
    async addCart(mnumber = 1, goods_id) {
      this.loading=true
      try {
        const res = await addCart(goods_id?goods_id:this.food.goods_id, mnumber)
        if (res.code === 10000) {
          if (this.food.spec_value != '') {

            for (var i in this.food.spec_list) {
              if (this.food.spec_list[i].goods_id == goods_id) {
                this.food.spec_list[i].cart_id = res.result.cart_id
                this.food.spec_list[i].count = mnumber
                break
              }
            }
          }
          this.$set(this.food, 'count', mnumber)
          this.$set(this.food, 'cart_id', res.result.cart_id)
          this.$emit(EVENT_ADD, event.target)
          this.$store.dispatch('addShopCart', res.result)
        }
        this.loading = false
      } catch(error) {
        console.log(error)
        Toast(this.$t('store.non_business_hours'))
        this.loading = false
      }
    },
    editCart (count,cart_id) {
      this.loading = true
      editCart(cart_id?cart_id:this.food.cart_id, count).then((res) => {
        if (res.code === 10000) {
          if(this.food.spec_value ==''){
            this.food.count = count
          }
          this.$store.dispatch('editShopCart', {cart_id: cart_id? cart_id : this.food.cart_id, count: count})
        }
        this.loading = false
      }).catch((error) => {
        Toast(error.message)
        this.loading = false
      })
    },
    delCart (cart_id) {
      this.loading = true
      delCart(cart_id? cart_id : this.food.cart_id).then((res) => {
        if (res.code === 10000) {
          this.$store.dispatch('deleteShopCart', {cart_id: cart_id? cart_id : this.food.cart_id})
        }
        this.loading = false
      }).catch((error) => {
        Toast(error.message)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .cartcontrol
    display: flex
    align-items: center
    border:.1rem solid #f4c41e;
    border-radius:0.9rem;
    .cart-decrease
      display: inline-block
      line-height: 0.9rem
      padding: 0.3rem
      opacity: 1
      .inner
        display: inline-block
        line-height: 0.9rem
        font-size: 0.9rem
        color: #f4c41e
        transition: all 0.4s linear
        transform: rotate(0)
      &.move-enter-active, &.move-leave-active
        transition: all 0.4s linear
      &.move-enter, &.move-leave-active
        opacity: 0
        transform: translate3d(0.9rem, 0, 0)
        .inner
          transform: rotate(180deg)
    .cart-count
      width: 0.6rem
      line-height: 0.9rem
      text-align: center
      font-size: 0.5rem
      color: #666
    .cart-add
      display: inline-block
      padding: 0.3rem
      line-height: 0.9rem
      font-size: 0.9rem
      color: #f4c41e
</style>
